export const TOGGLE_BOOK_EXTENDED_TIMES = 'toggle-book-extended-times';
const toggleBookExtendedTimes = () => ({ type: TOGGLE_BOOK_EXTENDED_TIMES });
export default toggleBookExtendedTimes;
